import React, { Component } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import {
  application,
  getGuestSignupOrigin,
  getParsedPhoneNumber,
  i18nTranslate,
  IS_BROWSER,
  signUpRedirectionForDirectSellerPopUp,
  trackContactMe,
} from 'src/utils'
import CommonForm from '../../CommonForm'
import { importedDeviceFormInput } from './formInput'
import { getDefaultSchema } from './validationSchema'
import { FaCheckCircle } from 'react-icons/fa'
import { toastState } from '../../Toast'
import {
  accountsContainer,
  cartContainer,
  catalogContainer,
  customerContainer,
  storeContainer,
} from 'src/models'
import {
  APPConfig,
  consentIpAddress,
  getLocalStorage,
  getSessionStorage,
  setLocalStorage,
} from 'config/appConfig'
import { signInwithRedirect } from 'src/utils/signInUtils'
import { GrClose } from 'react-icons/gr'
import { getMysiteSponsor, isEquinoxMysiteUrl } from 'src/utils/mySiteUtils'
import { countryData } from '../../SignUpForms/countryCodeData'
import { parsePhoneNumberField } from 'src/utils/signUpUtils'
import { SPONSOR } from 'src/utils/constant'
import './styles.scss'

export class NotifyDirectSellerPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isUserAlreadyContacted: false,
      isFormSubmitted: false,
      isFormValid: false,
      isLoading: true,
      directSellerProductList: [],
      validationErrors: {},
      parsedPhoneNumber: '',
    }
    this.productListRef = React.createRef()
  }

  async componentDidMount() {
    cartContainer.setSelectedPreferContactMethod('SMS')
    const { profileResponse } = customerContainer || {}
    const { product } = this.props || {}
    if (profileResponse) {
      const { phoneNumber, email, referenceAttribute1 } = profileResponse || {}
      if (customerContainer.isRegisterUser) {
        const isAlreadyContacted =
          await this.checkIfUserAlreadyContacted(referenceAttribute1)
        if (isAlreadyContacted) {
          this.setState({
            isUserAlreadyContacted: true,
            isLoading: false,
          })
        } else {
          const { phoneNumberCode } = await getParsedPhoneNumber(
            phoneNumber || ''
          )
          this.setState({ parsedPhoneNumber: phoneNumberCode || '' })
          this.fetchDirectSellerProductDetails()
        }
      } else {
        this.setState({
          isLoading: false,
        })
      }
      if (phoneNumber || email) {
        this.setState({ isFormValid: true })
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
      cartContainer.setSelectedPreferContactMethod('SMS')
    }

    if (prevState.isFormValid !== this.state.isFormValid) {
      const { phoneNumber, email } = customerContainer?.profileResponse
      if (phoneNumber || email) {
        this.setState({ isFormValid: true })
      } else {
        this.setState({ isFormValid: false })
      }
    }
  }

  checkIfUserAlreadyContacted = async customerId => {
    let isProductAlreadyContacted = false
    const res =
      await catalogContainer.checkIfUserContactedForDSproduct(customerId)
    if (res?.interestedProducts?.length > 0) {
      isProductAlreadyContacted = res?.interestedProducts?.some(
        item =>
          item === this.props?.product?.productId ||
          item === this.props?.product?.skuId
      )
    }
    return isProductAlreadyContacted
  }

  fetchDirectSellerProductDetails = async () => {
    const res = await catalogContainer.getDirectSellerProductDetails()
    const productList = res?.product || []
    const selectedProductId =
      this.props?.product?.productId || this.props?.product?.identifier
    const updatedProductList = productList.map(item => {
      const id = item?.productId || item?.identifier
      return {
        ...item,
        isSelected: id === selectedProductId,
      }
    })
    if (!res?.error) {
      this.setState({
        directSellerProductList: updatedProductList || [],
        isLoading: false,
      })
    } else {
      this.setState({
        isLoading: false,
      })
    }
  }

  localStorageCallbackDirectSellerPopUp = () => {
    const { product } = this.props || {}
    setLocalStorage('isToShowNotifyDirectSellerPopup', true)
    setLocalStorage('skuDetailsForNotifyDirectSeller', {
      productId: product?.productId || product?.identifier,
      skuId: product?.skuId || product?.sku[0]?.identifier,
    })
  }

  handleSignInButtonClick = () => {
    this.localStorageCallbackDirectSellerPopUp()
    this.props.onClose()
    signInwithRedirect()
  }

  handleSignUpButtonClick = () => {
    this.localStorageCallbackDirectSellerPopUp()
    const curPageURL = getLocalStorage('curPageUrl') || ''
    setLocalStorage('redirectionURLForDirectSellerPopUp', curPageURL)
    this.props.onClose()
    signUpRedirectionForDirectSellerPopUp()
  }

  handleFormChange = ({ values, touched, isFormValid }) => {
    if (this.state.contactErrorText) {
      this.setState({ contactErrorText: false })
    }

    if (
      this.state.validationErrors &&
      Object.keys(this.state.validationErrors).length > 0
    ) {
      this.setState({ validationErrors: {} })
    }
  }

  validateFormBeforeSubmit = async formData => {
    const { getDefaultSchema } = require('./validationSchema')
    const schema = getDefaultSchema()

    try {
      await schema.validate(formData, { abortEarly: false })
      return { isValid: true, errors: {} }
    } catch (validationError) {
      const errors = {}
      validationError.inner.forEach(error => {
        errors[error.path] = error.message
      })
      return { isValid: false, errors }
    }
  }

  updateUserPrivacyConsentForDSPopup = async () => {
    let allSignupConsents = []
    const { consents } = await customerContainer.signupConsents()
    if (Array.isArray(consents) && consents.length) {
      allSignupConsents = consents
    }
    const consentWithTitle = allSignupConsents?.find(
      c => c.title === 'privacy_noprivacy~0'
    )
    const consentPrivacyId = consentWithTitle?.id || ''
    const userId = customerContainer?.profileResponse?.id || ''
    const updateConsentData = {
      userId: userId,
      browser: 'chrome',
      device: application.deviceType,
      geoLocation:
        storeContainer.currentRegion || getLocalStorage('currentRegion') || '',
      ipAddress: consentIpAddress,
      createdBy: userId,
    }
    const apiPrivacyResponse =
      await customerContainer.updateUserPrivacyConsents({
        userConsent: [{ ...updateConsentData, consentId: consentPrivacyId }],
      })
  }

  handleFormSubmit = async formData => {
    const { onClose } = this.props
    console.log('formData', formData)
    const validation = await this.validateFormBeforeSubmit(formData)
    if (!validation.isValid) {
      this.setState({ validationErrors: validation.errors })
      return
    }
    this.setState({ validationErrors: {} })

    const { firstName, lastName, phone, userEmailAddress } = formData || {}
    const phoneNumber = await parsePhoneNumberField(
      phone,
      formData['Phone Number']
    )
    if (phone || userEmailAddress) {
      const contactInfo = {
        name: `${firstName} ${lastName}`,
        phone: `${phoneNumber?.number}` || '',
        email: userEmailAddress || '',
      }
      let bundleArray = ['bundle', 'fixedpricebundle', 'kit']
      const productArr = this.state.directSellerProductList
        ?.filter(item => item.isSelected === true)
        ?.map(item => {
          return {
            id: bundleArray.includes(item?.type?.toLowerCase())
              ? item?.identifier
              : item?.sku?.[0]?.identifier,
            name: item?.properties?.name,
          }
        })
      let learnMore = ''
      if (productArr.length > 0) {
        const allProductNames = productArr.map(p => p.name).join(', ')
        learnMore = [{ item_name: allProductNames }]
      }
      const { product } = this.props || {}
      const mainProductId = product?.productId || product?.identifier
      const userType =
        customerContainer?.profileResponse?.accounts?.accountType ===
        'Preferred Customer/Member'
          ? 'Member'
          : 'Retail Customer'
      const productInfoArr =
        productArr?.length > 0
          ? productArr
          : [
              {
                id: mainProductId,
              },
            ]
      const payLoad = {
        customerId:
          `${customerContainer?.profileResponse?.referenceAttribute1}` || '',
        contactInfo,
        communicationPreference:
          cartContainer?.selectedPreferContactMethod?.toLowerCase() || 'sms',
        productInfo: [...productInfoArr],
        sellerId:
          isEquinoxMysiteUrl() && userType === 'Retail Customer'
            ? getSessionStorage(SPONSOR) || 'INRETFLOAT'
            : accountsContainer?.getUserTypeSponsorId() || 'INRETFLOAT',
        source: getGuestSignupOrigin(),
        type: userType || '',
      }
      let oktaAccessToken = ''
      if (IS_BROWSER) {
        oktaAccessToken = localStorage.getItem('accessToken')
      } else {
        console.warn('oktaAccessToken is not available in browser')
      }
      const loadParams = {
        endPointName: 'notifyDirectSeller',
        postData: payLoad,
        headers: { Authorization: `Bearer ${oktaAccessToken}` },
      }

      // API intergation logic will come here.
      const response =
        await customerContainer.getNotificationApiResponse(loadParams)
      if (response) {
        //Consent Chnages
        this.updateUserPrivacyConsentForDSPopup()
        // Track the Contact Me event
        trackContactMe({
          contactPrefer: cartContainer?.selectedPreferContactMethod || 'SMS',
          learnMore,
        })

        if (
          customerContainer.isSuccessResponse(response) &&
          typeof cartContainer.onNotifyDirectSellerSuccess === 'function'
        ) {
          await cartContainer.onNotifyDirectSellerSuccess()
          cartContainer.onNotifyDirectSellerSuccess = null
        }

        this.setState({ isFormSubmitted: true })
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'consent.errorWhileUpdate',
            'Something went wrong. Please try again!'
          ),
          false
        )
      }
    }
  }
  checkBoxHandler = (e, id) => {
    const updateProductList = this.state.directSellerProductList?.map(
      product =>
        product?.identifier === id
          ? { ...product, isSelected: e.target.checked }
          : product
    )
    this.setState({ directSellerProductList: updateProductList })
  }

  renderSubmitButtonProps = () => {
    return (
      <>
        {this.state.directSellerProductList.length > 0 &&
          this.renderDirectSellerProductListWithCheckBox()}

        <Modal.Footer className="border-top-0 d-flex flex-column fl pl-0">
          <Button
            type="submit"
            className="imported-contactMe-button w-100 p-3 rounded-pill"
            disabled={!this.state.isFormValid}
            variant="primary"
            data-testid="qa-imported-device-save">
            {i18nTranslate(
              'notifyDirectSellerPopup.conatctMe',
              'Contact Me'
            )}
          </Button>
        </Modal.Footer>
      </>
    )
  }

  renderDirectSellerProductListWithCheckBox = () => {
    return (
      <>
        <p className="mt-3">
          {i18nTranslate(
            'notifyDirectSellerPopup.productText',
            "I'd like to learn more about"
          )}
        </p>
        <div
          className="direct-seller-product-list"
          ref={this.productListRef}
          style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {this.state.directSellerProductList.map((product, index) => (
            <div key={product?.identifier} className="form-check-list">
              <Form.Check
                label=""
                type="checkbox"
                checked={product?.isSelected}
                disabled={
                  (this.props?.product?.productId ||
                    this.props?.product?.identifier) === product?.identifier
                }
                value={product?.identifier}
                id={`product-${product?.identifier}`}
                key={product?.identifier}
                onChange={e => this.checkBoxHandler(e, product?.identifier)}
                onMouseDown={e => e.preventDefault()}
              />
              <label
                className="form-check-label"
                onMouseDown={e => e.preventDefault()}
                onClick={() => {
                  const isDisabled =
                    (this.props?.product?.productId ||
                      this.props?.product?.identifier) === product?.identifier
                  if (!isDisabled) {
                    this.checkBoxHandler(
                      { target: { checked: !product?.isSelected } },
                      product?.identifier
                    )
                  }
                }}>
                <img
                  className="product-image"
                  width={40}
                  height={40}
                  src={
                    product?.properties?.imageURL ||
                    product?.sku?.[0]?.skuProperties?.imageURL
                  }
                  alt={product?.properties?.name}
                />
                {product?.properties?.name}
              </label>
            </div>
          ))}
        </div>
      </>
    )
  }

  renderContactDetailsForm = () => {
    return (
      <Modal.Body className="p-4">
        <b>
          {i18nTranslate(
            'notifyDirectSellerPopup.text',
            'This product is available to Direct Sellers only.'
          )}{' '}
        </b>
        <br />
        {i18nTranslate(
          'notifyDirectSellerPopup.provideContactInfo',
          "Please provide your contact information and we'll have a Direct Seller reach out to you."
        )}
        <br />
        <br />
        <>
          {i18nTranslate(
            'notify.direct.seller.privacy.notice',
            'Nu Skin will provide your contact details to an independent brand   representative, who will contact you with more information about our  exclusive beauty and wellness products and special offers. You can withdraw your consent at any time. See our'
          )}{' '}
          <a
            href="https://legal.nuskin.com/privacy.html"
            className="text-violet"
            target="_blank"
            rel="noopener noreferrer">
            <u>{i18nTranslate('signup.privacyNotice', 'Privacy Notice')}</u>
          </a>{' '}
          {i18nTranslate('notify_direct_seller_learn_more', 'to learn more.')}
        </>
        <br />
        <br />
        <CommonForm
          formTypeJson={importedDeviceFormInput(
            this.state.validationErrors,
            this.state.parsedPhoneNumber
          )}
          schema={getDefaultSchema()}
          hasInlineSubmitButton={false}
          onSubmit={this.handleFormSubmit}
          getFormValuesOnChange={this.handleFormChange}
          SubmitButtonProps={this.renderSubmitButtonProps}
        />
      </Modal.Body>
    )
  }

  renderThankyouForm = () => {
    return (
      <Modal.Body className="imported-device-thanks-block">
        <div className="d-flex justify-content-center">
          <div className="outer-circle">
            <FaCheckCircle size={180} fill="#617a63" />
          </div>
        </div>
        <h4 className="text-center mt-4">
          {i18nTranslate('notifyDirectSellerPopup.thanks', 'Thanks!')}
        </h4>
        <p className="text-center">
          {i18nTranslate(
            'notifyDirectSellerPopup.contactText',
            'A Direct Seller will be in touch with you soon.'
          )}
        </p>
        <Modal.Footer className="border-top-0 d-flex flex-column fl pl-0">
          <Button
            className="imported-okay-button imported-contactMe-button p-3 rounded-pill"
            onClick={this.props.onClose}
            data-testid="qa-imported-device-okay">
            {i18nTranslate('notifyDirectSellerPopup.okay', 'Okay')}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    )
  }

  renderLoginOrSignupForm = () => {
    return (
      <Modal.Body>
        <p className="text-center mb-4">
          {i18nTranslate(
            'notifyDirectSellerPopup.signInOrSignUp',
            'Sign up or sign in to inquire about this product'
          )}
        </p>
        <Button
          className="imported-contactMe-button w-100 p-3 mt-3 rounded-pill"
          onClick={this.handleSignInButtonClick}
          data-testid="qa-imported-device-signIn">
          {i18nTranslate('notifyDirectSellerPopup.signIn', 'Sign In')}
        </Button>
        <p className="text-center mt-4 mb-2">
          {i18nTranslate(
            'notifyDirectSellerPopup.signUpAccountText',
            "Don't have an account?"
          )}
        </p>
        <Button
          className="imported-cancel-button w-100 p-3 rounded-pill mt-2 text-dark"
          onClick={this.handleSignUpButtonClick}
          data-testid="qa-imported-device-close">
          {i18nTranslate('checkout.signUp', 'Sign up')}
        </Button>
      </Modal.Body>
    )
  }

  alreadyContactedOkayHandler = async () => {
    this.props.onClose()
    if (typeof cartContainer.onNotifyDirectSellerSuccess === 'function') {
      await cartContainer.onNotifyDirectSellerSuccess()
      cartContainer.onNotifyDirectSellerSuccess = null
    }
  }

  renderUserAlreadyContactedForm = () => {
    return (
      <Modal.Body className="imported-device-already-contacted-block">
        <p className="ml-2">
          {i18nTranslate(
            'notifyDirectSellerPopup.contactYouSoon',
            'Someone will contact you soon!'
          )}
        </p>
        <Modal.Footer className="border-top-0 d-flex flex-column fl pl-0">
          <Button
            className="w-100 imported-contactMe-button p-3 rounded-pill"
            onClick={this.alreadyContactedOkayHandler}
            data-testid="qa-imported-device-okay">
            {i18nTranslate('notifyDirectSellerPopup.okay', 'Okay')}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    )
  }

  enableNotifyDirectSeller = () => {
    return APPConfig?.getAppConfig()?.enableNotifyDirectSeller === 'true'
  }

  render() {
    const userType = customerContainer?.profileResponse?.accounts?.accountType
    const userTypeNotBA =
      userType === 'Retail Customer' || userType === 'Preferred Customer/Member'
    if (customerContainer.isRegisterUser && !userTypeNotBA) {
      return <></>
    }
    if (!this.enableNotifyDirectSeller()) {
      return toastState.setToastMessage(
        i18nTranslate(
          'consent.importedDeviceError',
          'Imported Products are not available to purchase.'
        ),
        false
      )
    }
    return (
      !this.state.isLoading && (
        <Modal
          className={
            !customerContainer.isRegisterUser ? 'notify-direct-popup' : ''
          }
          dialogClassName={
            this.state.isUserAlreadyContacted ? 'already-contacted-popup' : ''
          }
          show={this.props.isOpen}
          onHide={this.props.onClose}
          centered>
          <Modal.Header className="border-0 pb-0 pl-4 pr-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {!this.state.isFormSubmitted && (
                  <Modal.Title className="notify-direct-title">
                    {this.state.isUserAlreadyContacted
                      ? i18nTranslate(
                          'notifyDirectSellerPopup.alreadyContactedTitle',
                          "We've updated your interest"
                        )
                      : i18nTranslate(
                          'notifyDirectSellerPopup.title',
                          'Interested in this Product?'
                        )}
                  </Modal.Title>
                )}
              </div>
              <div className="ssm-close-icon">
                <GrClose type="button" onClick={() => this.props.onClose()} />
              </div>
            </div>
          </Modal.Header>
          {!customerContainer.isRegisterUser
            ? this.renderLoginOrSignupForm()
            : this.state.isUserAlreadyContacted
              ? this.renderUserAlreadyContactedForm()
              : !this.state.isFormSubmitted
                ? this.renderContactDetailsForm()
                : this.renderThankyouForm()}
        </Modal>
      )
    )
  }
}

export default NotifyDirectSellerPopup
